import { FormControl, Validators } from "@angular/forms";

export const TenantNameValidation = Validators.pattern('^[ A-Za-z0-9_@./#&+-]*$');
export const NameValidation = Validators.pattern(/^[a-zA-Z\s]+$/);
export const FloatFieldValidation = Validators.pattern(/^[0-9]+(\.[0-9]{1,3})?$/);
export const PositiveIntFieldValidation = Validators.pattern(/^[0-9]{1,3}$/);
export const AlphaNumericValidation = Validators.pattern(/^[a-zA-Z0-9]+$/);
export const MobileNumberValidation = Validators.pattern(/^[0-9]{10}$/);
// export const TelephoneNumberValidation = Validators.pattern(/^[0-9]{10,50}$/);
export const TelephoneNumberValidation = Validators.pattern(/^([0-9]+(\s*,\s*[0-9]+)*)$/);//with comma and space for multiple, but number from 10 to 15 digits
export const WeightValidation = Validators.pattern(/^(?!0(?:\.0*)?$)\d{0,3}(?:\.\d{0,3})?$/);
export const VolumetricValidation = Validators.pattern(/^(?!0(?:\.0*)?$)\d{0,5}(?:\.\d{0,3})?$/);
export const RateValidation = Validators.pattern(/^(?!0(?:\.0*)?$)(?:\.\d{0,2})?$/);
export const WholeNumberValidation = Validators.pattern(/^(?!0)\d{1,3}$/);
// export const UrlValidation = Validators.pattern('^(?!https?:\/\/www\\.com$)(https?:\/\/)?(((www\\.(?!com$)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})|([a-zA-Z0-9.-]+)\\.com))(?<!www\.)(:\d+)?(/\\S*)?$');
export const UrlValidation = Validators.pattern('^(?!https?:\/\/www\\.com$)(https?:\/\/)?(www\\.)?([a-zA-Z0-9.-]+)\\.([a-zA-Z]{2,})(:\\d+)?(/\\S*)?$');
export const EmailValidation = Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$');
export const PortValidation = Validators.pattern('([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])');
export const PasswordValidation = Validators.pattern(/^.{5,20}$/);
export const GSTValidation = Validators.pattern('^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$');//GST breakup -(1,2)statecode (3,12)PANno. (13)EntityCode (14)blank (15)checkdigit
export const PANValidation = Validators.pattern(/^[A-Z]{5}\d{4}[A-Z]$/);//PAN -(1,5)alphabet (6,9)numbers (10)checkcode
export const REGNOValidation = Validators.pattern(/^.{5,20}$/);
export const CommentValidation = Validators.pattern(/^.{0,250}$/);
export const PincodeValidation = Validators.pattern(/^[0-9a-zA-Z]{6,10}$/);
export const AadhaarValidation = Validators.pattern('^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$');
export const PassportValidation = Validators.pattern('^[A-PR-WY-Z][1-9]\\d\\s?\\d{4}[1-9]$');//india passport validation
export const TanValidation = Validators.pattern('^[A-Z]{4}[0-9]{5}[A-Z]{1}');
export const FileSize = 1000000; //1 Mb File Size in Bytes

// Custom validator function to prevent 0
export const nonZeroValidator = (control: FormControl) => {
  return control.value > 0 ? null : { nonZero: true };
}

export const AmountValidation = Validators.pattern(/^(?!0(?:\.0*)?$)\d{0,12}(?:\.\d{0,3})?$/);
export const regexPattern = {
  nameField: /^[a-zA-Z\s]+$/,
  floatField: /^[0-9]+(\.[0-9]{1,3})?$/,
  positiveIntField: /^[0-9]{1,3}$/,
  alphaNumeric: /^[a-zA-Z0-9]+$/,
  telephone: /^[0-9]{10}$/,
  lbh: /^(?!0(?:\.0*)?$)\d{0,3}(?:\.\d{0,3})?$/,
  rate: /^(?!0(?:\.0*?)?$)\d*(\.\d{1,3})?$/,
  wholeNumbers: /^(?!0)\d{1,3}$/, //0 invalid,
  gstValidation: /^(0[1-9]|1[0-9]|2[0-9]|3[0-7])[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[0-9A-Z]{1}$/,
  panValidation: /^[A-Z]{5}\d{4}[A-Z]$/,
  adhaarValidation: /^[0-9]{12}$/,
  generalDocValidation: /^[0-9a-zA-Z]{0,30}$/,
  maxCharacterDocValidation: /^[0-9a-zA-Z]{0,150}$/
};

// pincode validation over country
export const pincodePattern = {
  AD: /^(?:\d{5}|[A-Za-z]{2}\d{3})$/, // Match 99999 or AA999
  AM: /^\d{4}$/,           // Armenia: 9999
  AR: /^\d{4}$/,           // Argentina: 9999
  AS: /^\d{5}$/,           // American Samoa: 99999
  AT: /^\d{4}$/,           // Austria: 9999
  AU: /^\d{4}$/,           // Australia: 9999
  AZ: /^\d{4}$/,           // Azerbaijan: 9999
  BA: /^\d{5}$/,           // Bosnia and Herzegovina: 99999
  BD: /^\d{4}$/,           // Bangladesh: 9999
  BE: /^\d{4}$/,           // Belgium: 9999
  BG: /^\d{4}$/,           // Bulgaria: 9999
  BN: /^[A-Za-z]{2}\d{4}$/,// Brunei: AA9999
  BR: /^(\d{5}(-\d{3})?|\d{8})$/,  // Brazil: 99999 or 99999-999 or 99999999
  BY: /^\d{6}$/,             // Belarus: 999999
  
  CA: /^[A-Za-z]\d[A-Za-z]( \d[A-Za-z](\d)?)?$/, // Canada: A9A, A9A 9A, or A9A 9A9
  CH: /^\d{4}$/,               // Switzerland: 9999
  CN: /^\d{6}$/,               // China, People’s Republic: 999999
  CO: /^\d{6}$/,               // Colombia: 999999
  CU: /^\d{5}$/,               // Cuba: 99999
  CY: /^\d{4}$/,               // Cyprus: 9999
  CZ: /^\d{3} \d{2}$/,          // Czech Republic: 999 99
  DE: /^\d{5}$/,               // Germany: 99999
  DK: /^\d{4}$/,               // Denmark: 9999
  DZ: /^\d{5}$/,               // Algeria: 99999
  EC: /^\d{6}$/,               // Ecuador: 999999
  EE: /^\d{5}$/,               // Estonia: 99999
  ES: /^\d{5}$/,               // Spain: 99999
  FI: /^\d{5}$/,               // Finland: 99999
  FM: /^\d{5}$/,               // Micronesia, Federated States of: 99999
  FO: /^\d{3}$/,               // Faroe Islands: 999
  FR: /^\d{5}$/,               // France: 99999
  GB: /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s?\d[A-Za-z]{2}$/, // UK (all formats)
  
  GE: /^\d{4}$/,               // Georgia: 9999
  GF: /^\d{5}$/,               // French Guyana: 99999
  GG: /^[A-Za-z]{2}\d{1,2}\s?\d[A-Za-z]{2}$/, // Guernsey: AA99 9AA or AA9 9AA

  GL: /^\d{4}$/,               // Greenland: 9999
  GP: /^\d{5}$/,               // Guadeloupe: 99999
  GR: /^\d{3}\s?\d{2}$/,       // Greece: 999 99
  GU: /^[\d]{5}(-\d{4})?$/, // Guam: 99999, 99999-9999

  HR: /^\d{5}$/,               // Croatia: 99999
  HU: /^\d{4}$/,               // Hungary: 9999
  IC: /^\d{5}$/,               // Canary Islands: 99999
  ID: /^\d{5}$/,               // Indonesia: 99999
  IL: /^\d{7}$/,               // Israel: 9999999
  IN: /^\d{6}$/,               // India: 999999
  IS: /^\d{3}$/,               // Iceland: 999
  IT: /^\d{5}$/,               // Italy: 99999
  JE: /^[A-Za-z]{2}\d\s?\d[A-Za-z]{2}$/, // Jersey: AA9 9AA
  JP: /^\d{3}-\d{4}$/,         // Japan: 999-9999
  KG: /^\d{6}$/,               // Kyrgyzstan: 999999
  KH: /^\d{5}$/,               // Cambodia: 99999
  KR: /^\d{5}$/,               // South Korea: 99999
  KV: /^\d{5}$/,               // Kosovo: 99999
  KZ: /^\d{6}$/,               // Kazakhstan: 999999
  LI: /^\d{4}$/,               // Liechtenstein: 9999
  LT: /^\d{5}$/,               // Lithuania: 99999
  LU: /^\d{4}$/,               // Luxembourg: 9999
  LV: /^\d{4}$/,               // Latvia: 9999
  MA: /^\d{5}$/,               // Morocco: 99999
  MC: /^\d{5}$/,               // Monaco: 99999
  MD: /^\d{4}$/,               // Moldova: 9999
  ME: /^\d{5}$/,               // Montenegro: 99999
  MG: /^\d{3}$/,               // Madagascar: 999
  MH: /^\d{5}$/,               // Marshall Islands: 99999
  MK: /^\d{4}$/,               // Macedonia: 9999
  MN: /^\d{5,6}$/, // Mongolia: 99999, 999999

  MP: /^\d{5}$/,               // Northern Mariana Islands: 99999
  MQ: /^\d{5}$/,               // Martinique: 99999
  MV: /^\d{4,5}$/, // Maldives: 9999, 99999

  MX: /^\d{5}$/,               // Mexico: 99999
  MY: /^\d{5}$/,               // Malaysia: 99999
  NC: /^\d{5}$/,               // Format: 99999
  NL: /^\d{4}(\s[A-Za-z]{2})?$/, // Netherlands: 9999, 9999 AA

  NO: /^\d{4}$/,               // Format: 9999
  NZ: /^\d{4}$/,               // Format: 9999
  PG: /^\d{3}$/,               // Format: 999
  PH: /^\d{4}$/,               // Format: 9999
  PK: /^\d{5}$/,               // Format: 99999
  PL: /^\d{2}-\d{3}$/,         // Format: 99-999   
  PR: /^\d{5}$/,               // Format: 99999   
  PT: /^\d{4}-\d{3}$/,         // Format: 9999-999   
  PW: /^\d{5}$/,               // Format: 99999   
  RE: /^\d{5}$/,               // Format: 99999   
  RO: /^\d{6}$/,               // Format: 999999   
  RS: /^\d{5}$/,               // Format: 99999   
  RU: /^\d{6}$/,               // Format: 999999   
  SE: /^\d{3} \d{2}$/,         // Format: 999 99   
  SG: /^\d{6}$/,               // Format: 99999
  SH: /^[A-Za-z]{4} \d{2}[A-Za-z]{2}$/, // Format: AAAA 9A
  SI: /^\d{4}$/,               // Format: 9999   
  SK: /^\d{3} \d{2}$/,         // Format: 999 99   
  SM: /^\d{5}$/,               // Format: 99999   
  SZ: /^[A-Z]\d{3}$/,          // Format: A999   
  TH: /^\d{5}$/,               // Format: 99999   
  TN: /^\d{4}$/,               // Format: 9999
  TR: /^\d{5}$/,               // Format: 99999
  TW: /^\d{3,5}$/, // Taiwan: 999, 99999
  // Format: 99999    
  UA: /^\d{5}$/,               // Format: 99999
  US: /^\d{4,5}(-\d{4})?$/, // US: 99999, 99999-9999
  UZ: /^\d{6}$/,               // Format: 999999    
  VI: /^\d{5}$/,               // Format: 99
  XY: /^\d{5}$/,               // Format: 99
  YT: /^\d{5}$/,               // Format: 99
  ZA: /^\d{4}$/                // Format: 9999
};

export const pincodeRange = {
  AD: 5,
  AM: 4,
  AR: 4,
  AS: 5,
  AT: 4,
  AU: 4,
  AZ: 4,
  BA: 5,
  BD: 4,
  BE: 4,
  BG: 4,
  BN: 6,
  BR: 5,
  BY: 6,
  CA: 6,
  CH: 4,
  CN: 6,
  CO: 6,
  CU: 5,
  CY: 4,
  CZ: 6,
  DE: 5,
  DK: 4,
  DZ: 5,
  EC: 6,
  EE: 5,
  ES: 5,
  FI: 5,
  FM: 5,
  FO: 3,
  FR: 5,
  GB: 6,
  GE: 4,
  GF: 5,
  GG: 4,
  GL: 4,
  GP: 5,
  GR: 6,
  GU: 5,
  HR: 5,
  HU: 4,
  IC: 5,
  ID: 5,
  IL: 7,
  IN: 6,
  IS: 3,
  IT: 5,
  JE: 3,
  JP: 8,
  KG: 6,
  KH: 5,
  KR: 5,
  KV: 5,
  KZ: 6,
  LI: 4,
  LT: 5,
  LU: 4,
  LV: 4,
  MA: 5,
  MC: 5,
  MD: 4,
  ME: 5,
  MG: 3,
  MH: 5,
  MK: 4,
  MN: 6,
  MP: 5,
  MQ: 5,
  MV: 5,
  MX: 5,
  MY: 5,
  NC: 5,
  NL: 4,
  NO: 4,
  NZ: 4,
  PG: 3,
  PH: 4,
  PK: 5,
  PL: 6,
  PR: 5,
  PT: 8,
  PW: 5,
  RE: 5,
  RO: 6,
  RS: 5,
  RU: 6,
  SE: 6,
  SG: 6,
  SH: 8,
  SI: 4,
  SK: 6,
  SM: 5,
  SZ: 4,
  TH: 5,
  TN: 4,
  TR: 5,
  TW: 3,
  UA: 5,
  US: 5,
  UZ: 6,
  VI: 5,
  XY: 5,
  YT: 5,
  ZA: 4
};

export const mandatoryPincodeCountries: string[] = [
  'IN', 'US', 'CA', 'GB', 'DE', 'AU', 'FR', 'CN', 'JP', 'KR',
  'BR', 'RU', 'ZA', 'IT', 'ES', 'MX', 'NL', 'PL', 'SG', 'MY',
  'PK', 'PH', 'ID', 'AR', 'BD', 'TR', 'TH', 'UA', 'RO', 'SE',
  'NO', 'FI', 'BE', 'CH', 'AT', 'HU', 'IE', // Ireland uses Eircode now
];